import { trackAnalyticsEvent } from '../../lib/analytics';

export const trackHelpEvent = (eventType: string, payload: Record<string, any> = {}) => {
  void trackAnalyticsEvent(eventType, {
    path: typeof window !== 'undefined' ? window.location.pathname + window.location.hash : undefined,
    ...(payload as any),
  });
};

